"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uuid = exports.EntityId = void 0;
const zod_1 = require("zod");
/**
 * Платформенный entity-id в OmniFlow — UUIDv7 как строка.
 *
 * Зачем UUIDv7: первые 48 бит — timestamp в миллисекундах, поэтому id'ы
 * лексикографически сортируются по времени создания. Это даёт `ORDER BY id`
 * как cheap surrogate для `ORDER BY created_at` (никакого btree on timestamp
 * не нужно). Также cluster-friendly index — последовательные INSERT'ы пишут
 * в одну page B-tree, не fragment'ируют storage.
 *
 * Генерация: `id()` из `@omniflow/utils` (создаёт UUIDv7 строку).
 * Валидация: `z.string().uuid()` — zod не различает UUIDv4 vs v7 на формате,
 * принимает любой валидный UUID (это OK — формат тот же 8-4-4-4-12 hex).
 *
 * Все стандартные CRUD-сущности (Session, User, Trunk, Route, FlowRun, ...)
 * используют `EntityId`. Domain-специфические id с natural-key (например
 * `SipUserId = "${username}@${domain}"`) — спецслучай, не покрывается.
 *
 * @example
 *   // В domain shared.ts:
 *   import { EntityId } from '@omniflow/contracts-base';
 *   export const SessionId = EntityId;
 *
 *   // С branded type (nominal typing, опционально):
 *   export const SessionId = EntityId.brand<'SessionId'>();
 *   // → z.infer<typeof SessionId> = string & z.BRAND<'SessionId'>
 *   // SessionId присваивается UserId == TS error.
 */
exports.EntityId = zod_1.z.string().uuid();
/**
 * Generic UUID schema — для трейсов, correlation-id, request-id и любого
 * другого UUID который не является entity primary key. Семантически отличается
 * от `EntityId` намерением, runtime-валидация одинаковая.
 */
exports.Uuid = zod_1.z.string().uuid();
//# sourceMappingURL=id.js.map